import ModalButtonsComponent, {
	ModalButtonsComponentProps,
} from './ModalButtonsComponent';
export type { ModalButtonsComponentProps };

export default ModalButtonsComponent;
